import React from 'react'
import LockOutlined from '@mui/icons-material/LockOutlined'

import useI18n from 'hooks/useI18n'
import { LockBadge, LockLabel, Overlay } from './styled'

export default function LockedContentOverlay() {
  const { t } = useI18n()

  return (
    <Overlay aria-hidden="true">
      <LockBadge><LockOutlined /></LockBadge>
      <LockLabel>{t('exclusive_content_title')}</LockLabel>
    </Overlay>
  )
}
